import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Address, PersonalDetails } from 'components/forms'
import { Input } from 'components/fields'
import { Button, Note, FormDebug, Title } from 'components/misc'
import { wizard, meta } from 'helpers/decorators'
import { apiCodeLists, apiCommon, apiConfiguration } from 'helpers/decorators/api'
import validate from './award-unit-nominated-award-leader.validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

@apiConfiguration()
@apiCodeLists(['titles', 'genders'], { public: true })
@apiCommon({
  publicCountries: true,
})
@wizard({
  form: 'awardUnitRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate,
})
@meta({
  title: 'Nominated Award Leader',
  intlKey: 'moduleTitle.nominated_award_leader',
})
class AwardUnitNominatedAwardLeader extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    common: PropTypes.object.isRequired,
    values: PropTypes.object,
    errors: PropTypes.object,
    codeLists: PropTypes.object,
    configuration: PropTypes.object.isRequired,
    isConfigurationTrue: PropTypes.func.isRequired,
    handleGetAwardUnitRegistrationFieldsCustomization: PropTypes.func.isRequired
  }

  componentDidMount = () => {
    const organizationId =  get(this.props, 'values.helpers.selectedCountry.icId') || get(this.props, 'values.helpers.selectedCountry.naoId')

    this.props.handleGetAwardUnitRegistrationFieldsCustomization(organizationId)
  }


  render() {
    const {
      handleSubmit,
      onSubmit,
      values,
      errors,
      codeLists,
      common,
      configuration,
    } = this.props

    const minAgeCfg = get(configuration, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

    const showMiddleName = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactMiddleName.id)

    const showGender = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactGender.id)

    const showFirstLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine1.id)

    const showSecondLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine2.id)

    const showCity = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCity.id)

    const showZipCode = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressZipCode.id)

    const showRegion = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressRegion.id)

    const showCountry = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCountry.id)

    const showAddress = showFirstLine || showSecondLine || showCity || showZipCode || showRegion || showCountry

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage
            id='moduleTitle.nominated_award_leader'
            defaultMessage='Nominated Award Leader'
          />
        </Title>
        <Note margin='-15px 0 30px'>
          <FormattedMessage
            id='label.you_will_be_the_first_award_leader'
            defaultMessage='You will be the first Award Leader in your organisation. You will have rights to add more Award Leaders, Participants and manage whole process of the award through the Online Record Book system.'
          />
        </Note>

        <PersonalDetails
          prefix='awardLeaderRegistration'
          titles={get(codeLists, 'titles.list')}
          genders={showGender && get(codeLists, 'genders.list')}
          errors={errors}
          isOrganizationContact
          minAgeCfg={minAgeCfg}
          showMiddleName={showMiddleName}
        />

        <div className='row'>
          <div className='col-xs-12 col-xs-6 col-md-4'>
            <Input
              label='What is your role in your organisation?'
              name='awardLeaderRegistration.role'
              intlKey='label.what_is_your_role'
              optional
            />
          </div>
        </div>

        {showAddress && <>
          <Title h2>
            <FormattedMessage
              id='moduleTitle.address_details'
              defaultMessage='Address Details'
            />
          </Title>

          <Address
            prefix='awardLeaderRegistration'
            countries={showCountry && common.countries.list}
            showFirstLine={showFirstLine}
            showSecondLine={showSecondLine}
            showCity={showCity}
            showZipCode={showZipCode}
            showRegion={showRegion}
          />
        </>}

        <FormDebug values={values} errors={errors} />

        <div>
          <Button type='submit'>
            <FormattedMessage id='button.continue' defaultMessage='Continue' />
          </Button>
        </div>
      </form>
    )
  }
}

export default AwardUnitNominatedAwardLeader
